import { FileCheck2, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { getWhatsAppUrl } from "@/lib/whatsapp";
import { trackEvent, EVENTS } from "@/lib/tracking";
import { business } from "@/config/business";

const CONTRACT_INCLUDES = [
  { title: "Scheduled Inspection", desc: "Pemeriksaan terjadwal sesuai kesepakatan kontrak." },
  { title: "Cleaning", desc: "Pembersihan unit secara berkala." },
  { title: "Preventive Maintenance", desc: "Perawatan pencegahan yang terencana." },
  { title: "Condition Report", desc: "Laporan kondisi unit setiap kunjungan." },
  { title: "Maintenance History", desc: "Riwayat perawatan yang terdokumentasi." },
  { title: "Maintenance Planning", desc: "Perencanaan perawatan ke depan." },
  { title: "Spare Part Recommendation", desc: "Rekomendasi spare part bila diperlukan." },
];

export const MaintenanceContractSection = () => {
  return (
    <section
      id="maintenance-contract"
      data-testid="maintenance-contract-section"
      className="bg-white py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="06"
          kicker="Maintenance Contract"
          title="SEJUKARA Maintenance Contract"
          description="Jangan Tunggu Rusak. Jadwalkan Perawatan. Program maintenance berkala untuk perusahaan yang membutuhkan perawatan AC & HVAC secara rutin dan terjadwal."
        />

        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {CONTRACT_INCLUDES.map((c, i) => (
            <Reveal key={c.title} delay={(i % 3) * 0.07}>
              <div
                data-testid={`contract-item-${i}`}
                className="flex h-full items-start gap-3 rounded-2xl border border-slate-200 bg-[#F8FAFC] p-6"
              >
                <FileCheck2 className="mt-0.5 h-5 w-5 flex-none text-[#E0A400]" />
                <div>
                  <h3 className="text-base font-bold text-slate-900">{c.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{c.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}

          <Reveal delay={0.14}>
            <div className="flex h-full flex-col justify-between rounded-2xl bg-[#0F172A] p-6 text-white">
              <div>
                <h3 className="text-base font-bold">Diskusikan kebutuhan kontrak Anda</h3>
                <p className="mt-1.5 text-sm text-slate-300">Kami bantu susun program maintenance yang sesuai.</p>
              </div>
              <a
                href={getWhatsAppUrl(business.whatsappMessages.b2b)}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  trackEvent(EVENTS.REQUEST_MAINTENANCE_CONTRACT, { source: "maintenance_contract" });
                  trackEvent(EVENTS.WHATSAPP_CLICK, { source: "maintenance_contract" });
                }}
                data-testid="contract-cta"
                className="mt-5 inline-flex items-center justify-center gap-2 rounded-lg bg-[#25D366] px-5 py-3 text-sm font-bold text-white transition-colors hover:bg-[#1eb85a]"
              >
                <MessageCircle className="h-4 w-4" />
                {business.cta.requestContract}
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default MaintenanceContractSection;
